import { RENDERING_DEFAULTS } from '../constants/index.js';
export default function getViewSlabDepth(depth) {
    if (!Number.isFinite(depth) ||
        depth <= RENDERING_DEFAULTS.MINIMUM_SLAB_THICKNESS * 2) {
        return undefined;
    }
    return depth;
}
